import { useContext } from "react";

import { type NotificationName } from "components/shared/notifications/notifications";
import { usePolicyPlatformId } from "data/ss-data-hooks";
import { CoverageContext } from "pages/overview/extended-coverages/hooks";

export const useShowHomeServicesAlert = (
  availableNotifications: NotificationName[],
) => {
  return availableNotifications.includes("HomeServices");
};

export const useShowCancellationPaymentNotice = (
  availableNotifications: NotificationName[],
) => {
  return availableNotifications.includes("CancellationPayment");
};

export const useShowCoverageNotification = (
  availableNotifications: NotificationName[],
) => {
  const { coveragePage } = useContext(CoverageContext);
  const selectedPolicyId = usePolicyPlatformId();

  return (
    availableNotifications.includes("Coverage") &&
    coveragePage?.type &&
    selectedPolicyId === coveragePage.policyId
  );
};
